import type { ColumnProps } from 'antd/lib/table';

import { SummaryGroupByLabelsMap } from '@/components/reporting/summary-group-by';
import {
  createAmountColumn,
  createNumericColumn,
  createStringColumn,
} from '@/components/table/columns';
import { summaryGroupByValueFormatter } from '@/resources/channels/performance-summary/shared/formatters';

export const LifeInsuranceFunnelTableConfig = (
  groupBy: string
): Array<ColumnProps<any>> => [
  createStringColumn({
    key: 'groupKey',
    render: summaryGroupByValueFormatter,
    title: SummaryGroupByLabelsMap[groupBy],
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeads',
    title: 'Leads',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsSubmittedQuoteApp',
    title: 'Submitted Quote Application',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsSubmittedLeadApp',
    title: 'Submitted Lead Application',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsSubmittedAppToCarrier',
    title: 'Submitted Application to Carrier',
  }),
  createNumericColumn({
    align: 'right',
    key: 'numLeadsWithPolicy',
    title: 'Policy In force',
  }),
  createAmountColumn({
    align: 'right',
    key: 'totalPayout',
    title: 'Attributed Earnings',
  }),
];
